const HUBL_VAR_REGEXP = /^{{\s*([a-zA-Z0-9_.]+)\s*}}$/;
export const getHublVariable = str => {
  if (typeof str !== 'string') {
    return null;
  }
  const matches = str.trim().match(HUBL_VAR_REGEXP);
  return matches ? matches[1] : null;
};
const EmailSystemHublVariables = {
  UNSUBSCRIBE: 'unsubscribe_link',
  UNSUBSCRIBE_ALL: 'unsubscribe_link_all',
  VIEW_AS_WEBPAGE: 'view_as_page_url',
  SUBSCRIPTION_CONFIRMATION: 'subscription_confirmation_url'
};
export const getEmailSystemHublVar = str => {
  const hublVar = getHublVariable(str);
  for (const key in EmailSystemHublVariables) {
    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (hublVar === EmailSystemHublVariables[key]) {
      return hublVar;
    }
  }
  return null;
};